function f(u,t,a,r,e){return r+(e-r)*((u-t)/(a-t))}export{f as default};
//# sourceMappingURL=map.js.map
